<!-- TEMPLATE -->
<template>
  <div class="dean-header">
    <div class="dean-header-menu">
      <div class="row">
        <div class="small-9 medium-3 large-2 hd-2 columns">
          <dean-header-logo
            :logo="logo"
            :logoImg="logoImg"
            :width="logoWidth"
            :height="logoHeight"
            :defaultRoute="defaultRoute"
          ></dean-header-logo>
        </div>
        <div v-if="data" class="small-3 medium-0 large-0 hd-0 columns">
          <transition name="slide-fade">
            <dean-header-mobile-toggle
              :icon="burger"
              @click.native="showMobileMenu = !showMobileMenu"
            ></dean-header-mobile-toggle>
          </transition>
        </div>
        <div v-if="searchBar" class="small-0 medium-4 large-2 hd-4 columns">
          <slot name="dean-header-search"></slot>
        </div>
        <div v-if="searchBar" class="small-0 medium-5 large-8 hd-6 columns">
          <div class="dean-header-menu-items">
            <div class="dean-header-menu-items-group">
              <span class="large-up">
                <slot name="dean-header-items-primary"></slot>
              </span>
            </div>
            <div class="dean-header-menu-items-group">
              <span class="medium-only">
                <slot name="dean-header-items-primary-dropdown"></slot>
              </span>
              <span class="medium-up">
                <slot name="dean-header-items-secondary"></slot>
              </span>
            </div>
          </div>
        </div>
        <div v-else class="small-0 medium-9 large-10 hd-10 columns">
          <div class="dean-header-menu-items">
            <div class="dean-header-menu-items-group">
              <span class="large-up">
                <slot name="dean-header-items-primary"></slot>
              </span>
            </div>
            <div class="dean-header-menu-items-group">
              <span class="medium-only">
                <slot name="dean-header-items-primary-dropdown"></slot>
              </span>
              <span class="medium-up">
                <slot name="dean-header-items-secondary"></slot>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <dean-header-mobile v-if="showMobileMenu">
        <span slot="dean-header-mobile-top">
          <slot name="dean-header-mobile-top"></slot>
        </span>
        <span slot="dean-header-mobile-close">
          <dean-header-mobile-toggle
            :icon="close"
            @click.native="showMobileMenu = !showMobileMenu"
          ></dean-header-mobile-toggle>
        </span>
        <span slot="dean-header-mobile-content">
          <slot
            name="dean-header-items-mobile"
            @click.native="mobileMenuClose()"
          ></slot>
        </span>
      </dean-header-mobile>
    </transition>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanHeaderItem from './deanHeaderItem.vue';
import deanHeaderProfile from './deanHeaderProfile.vue';
import deanHeaderLogo from './deanHeaderLogo.vue';
import deanHeaderSearch from './deanHeaderSearch.vue';
import deanHeaderMobile from './deanHeaderMobile.vue';
import deanHeaderMobileToggle from './deanHeaderMobileToggle.vue';
import deanSearchField from './deanSearchField.vue';

// SVG
import burger from '../svg/icons/burger.svg';
import close from '../svg/feather-icons/x.svg';

@Component({
  components: {
    deanIcon,
    deanHeaderItem,
    deanHeaderLogo,
    deanHeaderSearch,
    deanHeaderMobile,
    deanHeaderMobileToggle,
    deanSearchField
  }
})
export default class deanHeader extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop() logo!: object;
  @Prop() logoWidth!: string;
  @Prop() logoHeight!: string;
  @Prop({ default: ''}) logoImg!: string;
  @Prop({ default: false }) searchBar!: boolean;
  @Prop({ default: false }) defaultRoute: boolean;

  // DATA
  showMobileMenu: boolean = false;
  burger: object = burger;
  close: object = close;
  

  // WATCH
  @Watch('$route')
  closeMobileMenu() {
    this.mobileMenuClose();
  }

  @Watch('showMobileMenu')
  mobileMenuState() {
    this.$emit('mobile-menu-state', this.showMobileMenu);
  }

  //METHODS
  mobileMenuClose() {
    this.showMobileMenu = false;
    console.log('showMobileMenu is false');
  }

  created() {
    console.log(this.$router);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER
.dean-header-menu {
  position: fixed;
  display: block;
  top: 0;
  width: 100%;
  background: white;
  height: 80px;
  z-index: 998;
  @include box-shadow(0px 3px 5px rgba(0, 0, 0, 0.075));
  .row,
  .column,
  .columns {
    height: 100%;
    overflow: hidden;
  }
  .dean-header-menu-items {
    display: flex;
    height: 100%;
    justify-content: space-between;
    .dean-header-menu-items-group {
      height: 100%;
      min-width: 1px;
      span {
        height: 100%;
      }
    }
  }
}

// TRANSITIONS
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
